<div class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim-profile dropdown-menu-top-unround dropdown-menu-xl d-none" x-placement="top-end" style="position: absolute; transform: translate3d(-175px, 50px, 0px); top: 0px; left: 0px; will-change: transform;">

									<!--begin: Head -->
									<div class="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x" style="background-image: url(./assets/image/bg-1.jpg)">
										<div class="kt-user-card__avatar">
											<img class="kt-hidden" alt="Pic" src="./assets/image/0.jpg">

											<!--use below badge element instead the user avatar to display username's first letter(remove kt-hidden class to display it) -->
											<!-- <span class="kt-badge kt-badge--lg kt-badge--rounded kt-badge--bold kt-font-success">G</span> -->
										</div>
										<div class="kt-user-card__name">
											Gaurav Gupta
										</div>
										<div class="kt-user-card__badge">
											<span class="btn btn-danger">Unverified</span>
										</div>
									</div>

									<!--end: Head -->

									<!--begin: Navigation -->
									<div class="kt-notification">
										<a routerLink="/userprofile" class="kt-notification__item">
											<div class="kt-notification__item-icon">
												<i class="flaticon2-calendar-3 kt-font-success"></i>
											</div>
											<div class="kt-notification__item-details">
												<div class="kt-notification__item-title kt-font-bold">
													Profile
												</div>
												<!-- <div class="kt-notification__item-time">
													Account settings and more
												</div> -->
											</div>
										</a>
										<a routerLink="/dataoffering" class="kt-notification__item">
											<div class="kt-notification__item-icon">
												<i class="flaticon2-rocket-1 kt-font-danger"></i>
											</div>
											<div class="kt-notification__item-details">
												<div class="kt-notification__item-title kt-font-bold">
													My Data Offerings
												</div>
											</div>
										</a>
										<a routerLink="/purchasehistory" class="kt-notification__item">
											<div class="kt-notification__item-icon">
												<i class="flaticon2-box-1 kt-font-brand"></i>
											</div>
											<div class="kt-notification__item-details">
												<div class="kt-notification__item-title kt-font-bold">
													My Purchase History
												</div>
												<!-- <div class="kt-notification__item-time">
													Inbox and tasks
												</div> -->
											</div>
										</a>
										<a routerLink="/billing" class="kt-notification__item">
											<div class="kt-notification__item-icon">
												<i class="flaticon2-cardiogram kt-font-warning"></i>
											</div>
											<div class="kt-notification__item-details">
												<div class="kt-notification__item-title kt-font-bold">
													Billing & Payments
												</div>
											</div>
										</a>
										<a  class="kt-notification__item" (click)="delete_account()">
											<div class="kt-notification__item-icon">
												<i class="flaticon2-line-chart kt-font-success"></i>
											</div>
											<div class="kt-notification__item-details">
												<div class="kt-notification__item-title kt-font-bold">
													Delete account
												</div>
											</div>
										</a>
										<div class="kt-notification__custom kt-space-between">
											<a href="/"  class="btn btn-label btn-label-brand btn-sm btn-bold">LogOut</a>
											<a routerLink="/upgradeplan" class="btn btn-clean btn-sm btn-bold">Upgrade Plan</a>
										</div>
									</div>

									<!--end: Navigation -->
								</div>

<!-- delete account modal -->

<div class="modal fade delete_account_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg modal-md" role="document">
    <div class="modal-content infomodal">
    	<div class="kt-portlet kt-portlet--skin-solid">
			<div class="kt-portlet__head kt-portlet__head--noborder" style="background-image: url(./assets/image/bg-1.jpg)">
				<div class="kt-portlet__head-label">
					<span class="kt-portlet__head-icon">
						<i class="flaticon2-graphic"></i>
					</span>
					<h3 class="kt-portlet__head-title">
						Delete Account
					</h3>
				</div>
				<div class="kt-portlet__head-toolbar">
					<div class="kt-portlet__head-actions">
						<a class="mr-1">
							<img src="./assets/image/icons/help_icon.png">
						</a>
						<a class="ml-1" data-target="data_classification" data-dismiss="modal">
							<img src="./assets/image/icons/close_icon.png">
						</a>
					</div>
				</div>
			</div>
			<div class="kt-portlet__body">
				<form class="kt-form kt-form--label-right">
				   <div class="kt-section kt-section--first">
					   <div class="kt-section__body">
						   <div class="row">
							   <div class="col-lg-12 col-xl-12 delete_account_heading"> Before you can mark your account for closure, you must review and select the following check boxes to acknowledge that you've reviewed each of the most common account closure effects. </div>
						   </div>
						   <div class="form-group row mt-3">
							   <label  class="kt-checkbox kt-checkbox--success"><input  type="checkbox" name="check">I understand that by clicking this checkbox, I am closing my DataPitcher account. The closure of my DataPitcher account serves as notice to DataPitcher that I wish to terminate the DataPitcher Customer Agreement or any other agreement with DataPitcher that governs my DataPitcher account, solely with respect to that DataPitcher account. <span class="mt-1"></span></label>
						   </div>
						   <div class="form-group row">
							   <label  class="kt-checkbox kt-checkbox--success"><input  type="checkbox" name="check">I understand that after the Post-Closure Period I will no longer be able to reopen my closed account. <span class="mt-1"></span></label>
						   </div>
						   <div class="form-group row">
							   <label  class="kt-checkbox kt-checkbox--success"><input  type="checkbox" name="check"> I understand that after the Post-Closure Period I will no longer be able to access the DataPitcher Console to view past offerings and purchased invoices. <span class="mt-1"></span></label>
						   </div>
						   <div class="form-group row">
							   <label  class="kt-checkbox kt-checkbox--success"><input  type="checkbox" name="check"> I understand that after the Post-Closure Period I will not be able to create a new DataPitcher account with the email address or phone number currently associated with this account.<span class="mt-1"></span></label>
						   </div>
						   <div class="form-group row">
							   <label  class="kt-checkbox kt-checkbox--success"><input  type="checkbox" name="check">I understand that my data offerings already published will be retained by DataPitcher as per their agreement with purchaser of that offering.<span class="mt-1"></span></label>
						   </div>
						   <hr>
						   <div class="form-group row button">
							   <button class="btn btn-danger offset-md-4 offset-lg-5 offset-xl-5">DELETE ACCOUNT</button>
						   </div>
					   </div>
				   </div>
		       </form>
			</div>
			</div>
    </div>
  </div>
</div>

